import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../../shared/utils/consts';
import { DynamicLinkType } from '../../../shared/utils/enuns/dynamic-link-type';

@Component({
  selector: 'mobo-dynamic-link',
  templateUrl: './dynamic-link.component.html',
  styles: ``,
})
export class DynamicLinkComponent {
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    const snapshot = this.route.snapshot;
    const type = snapshot.url[0].path;
    const id = Object.values(snapshot.queryParams)[0];
    const store = snapshot.queryParams['store'];
    if (this.isStoreValid(store)) {
      this.redirectToStore(store);
    } else {
      this.redirect(type, id);
    }
  }

  isStoreValid(store: string | undefined) {
    return store && (store == 'ios' || store == 'android');
  }

  public redirectToStore(store: string) {
    if (store == 'ios') {
      window.location.href = APP_STORE_URL;
    } else if (store == 'android') {
      window.location.href = PLAY_STORE_URL;
    }
  }

  redirect(type: string, id: string) {
    if (!type || !id) {
      this.router.navigate(['/']);
    }
    type = type.toLowerCase();
    switch (type) {
      case DynamicLinkType.Campaign:
      case DynamicLinkType.Delivery:
        this.router.navigate(['cupom', id]);
        break;
      case DynamicLinkType.CommercialPlace:
        this.router.navigate(['restaurante', id]);
        break;
      default:
        this.router.navigate(['/']);
        break;
    }
  }
}
